
import { defineComponent } from "vue";
import TuitionPriceListsContent from "./components/TuitionPriceListsContent.vue";

export default defineComponent({
  name: "TuitionPriceListsPage",
  components: {
    TuitionPriceListsContent,
  },
});
